import province from './constant/province'
import country from './constant/country'

const initState = () => ({
  province:province,
  country:country,
  user:null,
  defaultColumn:[],
  form:[],
  theme:{
  	backGround:{
  		color:'#00A79D',
  	},
  	button: {
      backGroundColor: '#00A79D',
      backGroundColorHover: '#038880',
      text: 'Results',
      color: '#ffffff',
      colorHover: "#ffffff",
      borderColor: '#d3e0ff',
      borderColorHover: "#ffffff"
    },
    text:{
      title:'ระบบสร้าง และ บริหารฟอร์มแบบออนไลน์',
      subTitle:'Anytime, Customize and Easy to use',
      logo:'logo-ace-form.png'
    }
  },
  tabPage:'list'
});

export default initState;
 